import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { from, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../../services/authentication-service/authentication.service';

export const authGuard: CanActivateFn = () => {
  const authService: AuthenticationService = inject(AuthenticationService);
  const router: Router = inject(Router);
  if (authService.isUserLoggedIn()) {
    return from(router.navigate(['initial-information'])).pipe(map(() => true));
  }
  return of(true);
};
